module.exports = __webpack_public_path__ + "img/welding-7.57428faf.jpg";